import { ReactNode } from "react";
import { Modal, Button } from "@mui/material";
import { tss } from "tss-react";
import { Close } from "@mui/icons-material";

const minHeight = 600;
const useStyles = tss.create({
    paper: {
        position: "absolute",
        width: 420,
        minHeight: minHeight,
        borderRadius: 4,
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "#FFFFFF",
        boxShadow: "5px 5px rgba(0,0,0,0.07)",
        padding: "15px 22px",
        border: "solid 1px rgba(0,0,0,0.07)",
        verticalAlign: "top",
        outline: "none"
    },
    button: {
        width: 30,
        height: 30,
        minWidth: 30,
    },
    closeButton: {
        position: "absolute",
        top: 10,
        right: -5,
        "& button": {
            color: "rgba(32,32,32,.6)",
            "&:hover": {
                background: "none"
            }
        }
    },
    icon: {
        position: "relative",
        width: 24,
        height: 24,
        verticalAlign: "middle",
        display: "inline-block",
    },
    content: {
        display: "flex",
        flexDirection: "column",
        verticalAlign: "top",
    },
});

type IProps = {
    open: boolean;
    width?: number;
    height?: any;
    minHeight?: any;
    paperStyle?: any;
    handleClose: () => void;
    children: ReactNode;
    onFocus?: () => void;
};

export default function ModalWindow(props: IProps) {
    const { classes } = useStyles();
    const { open, onFocus } = props;
    const body = (
        <div
            className={classes.paper}
            style={
                props.paperStyle
                    ? {
                          ...props.paperStyle,
                          width: props.width ? props.width : "",
                          height: props.height ? props.height : "",
                          minHeight: props.minHeight ? props.minHeight : minHeight,
                      }
                    : {
                          width: props.width ? props.width : "",
                          height: props.height ? props.height : "",
                          minHeight: props.minHeight ? props.minHeight : minHeight,
                      }
            }
        >
            <div className={classes.content}>
                {props.children}
                <div className={classes.closeButton}>
                    <Button
                        className={classes.button}
                        variant="text"
                        onClick={(e) => {
                            props.handleClose();
                        }}
                    >
                        <Close className={classes.icon} />
                    </Button>
                </div>
            </div>
        </div>
    );
    return (
        <div>
            <Modal
                open={open}
                onFocus={onFocus}
                onClose={props.handleClose}
                aria-labelledby="Create View"
                aria-describedby="Create View"
            >
                {body}
            </Modal>
        </div>
    );
}
